import React, { Component } from 'react';
import { Modal, notification } from 'antd';

import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

import MsgReader from 'wl-msg-reader/lib/msg.reader';
import { Col, Divider, Row } from 'antd';
import { isEmpty } from 'lodash';
import { emailPreviewExtensions, emailPreviewMimeTypes } from '../../../../../../shared/utils/files/file-upload-accepts';

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

import 'pdfjs-dist/web/pdf_viewer.css';

import { saveAs } from 'file-saver';

export default class PreviewFileDialog extends Component {
  state = {
    resource: null,
    loadingPdf: false,
    loadingMsg: false,
    msgReaderObj: null,
    msgData: {
      senderName: null,
      senderEmail: null,
      recipients: [],
      subject: null,
      body: null,
      headers: null,
      attachments: [],
    },
    msgAttachmets: [],
    msgDate: null,
  };
  canvasRef = React.createRef();

  async componentDidMount() {
    if (this.props.getResourceUrl && !this._isMounted) {
      const res = await this.props.getResourceUrl();
      if (res) {
        this.setState({ resource: res });

        if (res.contentType === 'application/pdf') {
          this.setState({ loadingPdf: true });

          fetch(res.url, { method: 'GET' })
            .then((response) => response.blob())
            .then(async (blob) => {
              const eventBus = new pdfjsViewer.EventBus();

              // (Optionally) enable hyperlinks within PDF files.
              const pdfLinkService = new pdfjsViewer.PDFLinkService({
                eventBus,
              });

              const pdfViewer = new pdfjsViewer.PDFViewer({
                container: this.canvasRef.current,
                eventBus,
                linkService: pdfLinkService,
                textLayerFactory: new pdfjsViewer.DefaultTextLayerFactory(),
                annotationLayerFactory: null,
              });

              pdfLinkService.setViewer(pdfViewer);

              eventBus.on('pagesinit', function () {
                // We can use pdfViewer now, e.g. let's change default scale.
                pdfViewer.currentScaleValue = 'page-width';
              });

              const loadingTask = pdfjsLib.getDocument({
                url: res.url,
              });

              loadingTask.promise.then((pdfDocument) => {
                // Document loaded, specifying document for the viewer and
                // the (optional) linkService.
                pdfViewer.setDocument(pdfDocument);

                pdfLinkService.setDocument(pdfDocument, null);
              });

              this.setState({ loadingPdf: false });
            })
            .catch((err) => {
              notification.error({
                message: 'Error',
                top: 55,
                duration: 10,
                getContainer: this.props.rootContainer,
                description: 'Something wrong happened during PDF load.',
              });
            });
        } else if (this.isMsgFile()) {
          this.setState({ loadingMsg: true });

          fetch(this.state.resource.url, { method: 'GET' })
            .then((response) => response.arrayBuffer())
            .then(async (result) => {
              let reader = new MsgReader(result);
              let fileData = reader.getFileData();

              this.setState({ msgReaderObj: reader });
              let msgAttachmentfiles = [];

              fileData.attachments.forEach((element, index) => {
                msgAttachmentfiles.push(reader.getAttachment(index));
              });

              let msgDate = this.getMsgDate(fileData.headers);

              this.setState({ msgAttachmets: msgAttachmentfiles });

              this.setState({ msgDate: msgDate });
              this.setState({ msgData: fileData });
              this.setState({ loadingMsg: false });
            })
            .catch((err) => {
              notification.error({
                message: 'Error',
                top: 55,
                duration: 10,
                getContainer: this.props.rootContainer,
                description: 'Something wrong happened during email file load.',
              });
            });
        }
      }
      this._isMounted = true;
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  downloadOriginalFile = () => {
    fetch(this.state.resource.url)
      .then((res) => res.blob())
      .then((blob) => saveAs(blob, this.state.resource.name));
  };

  isSupportedContentType = () => {
    return (
      this.state.resource &&
      (this.state.resource.contentType === 'application/pdf' || this.state.resource.contentType.startsWith('image/') || this.isMsgFile())
    );
  };

  isMsgFile = () => {
    return (
      !isEmpty(this.state.resource.name) &&
      emailPreviewExtensions.some((e) => this.state.resource.name.toLowerCase().endsWith(e)) &&
      emailPreviewMimeTypes.some((t) => t == this.state.resource.contentType.toLowerCase())
    );
  };

  downloadAttachment = (event) => {
    let index = event.target.getAttribute('data-index');

    if (this.state.msgAttachmets && this._isMounted && !this.loadingMsg) {
      let file = this.state.msgAttachmets[index];

      if (file) {
        let blob = new Blob([file.content], { type: file.mimeType ? file.mimeType : 'application/octet-stream' });

        saveAs(blob, file.fileName);
      }
    }
  };

  parseHeaders = (headers) => {
    let parsedHeaders = {};
    if (!headers) {
      return parsedHeaders;
    }
    let headerRegEx = /(.*)\: (.*)/g;
    let m;
    while ((m = headerRegEx.exec(headers))) {
      // todo: Pay attention! Header can be presented many times (e.g. Received). Handle it, if needed!
      parsedHeaders[m[1]] = m[2];
    }
    return parsedHeaders;
  };

  getMsgDate = (rawHeaders) => {
    if (rawHeaders) {
      let headers = this.parseHeaders(rawHeaders); //here we can find more headers
      let d = headers['Date'];
      if (!d) {
        return null;
      }
      return d;
    }
    return null;
  };

  render() {
    const { onHide, headerText, rootContainer } = this.props;

    return (
      <Modal title={headerText} getContainer={rootContainer} width="1000px" open={true} onCancel={onHide} footer={null}>
        {this.state.resource ? (
          <>
            {this.isSupportedContentType() ? (
              <>
                <div>
                  Click
                  <a href="#" onClick={this.downloadOriginalFile} style={{ padding: '0px 5px' }}>
                    here
                  </a>
                  to download the original file.
                </div>

                {this.state.resource.contentType.startsWith('image/') ? (
                  <div
                    style={{
                      width: '100%',
                      height: '60vh',
                      background: `url(${this.state.resource.url})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      backgroundSize: 'contain',
                    }}
                  ></div>
                ) : null}

                {this.state.resource.contentType === 'application/pdf' ? (
                  <div className="pdf-document-container">
                    <div
                      ref={this.canvasRef}
                      style={{
                        overflow: 'auto',
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                      }}
                    >
                      <div id="viewer" className="pdfViewer"></div>
                      {this.state.loadingPdf ? <div> Loading PDF...</div> : null}
                    </div>
                  </div>
                ) : null}

                {this.isMsgFile() && !this.state.loadingMsg ? (
                  <div className="code-box">
                    <Divider orientation="left" style={{ padding: 0 }}></Divider>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={4}>
                        From:
                      </Col>
                      <Col className="gutter-row" span={12}>
                        {this.state.msgData.senderEmail}
                        {this.state.msgData.senderEmail && this.state.msgData.senderEmail != this.state.msgData.senderName ? ' | ' : null}
                        {this.state.msgData.senderName != this.state.msgData.senderEmail ? this.state.msgData.senderName : null}
                      </Col>
                    </Row>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={4}>
                        To:
                      </Col>

                      {this.state.msgData.recipients.map((recipient, index) => {
                        return (
                          <Col id={'to-email-' + index} key={recipient} className="gutter-row" span={12}>
                            {recipient.email}
                            {recipient.email && recipient.email != recipient.name ? ' | ' : null}
                            {recipient.email != recipient.name ? recipient.name : null}
                          </Col>
                        );
                      })}
                    </Row>
                    {this.state.msgData.subject ? (
                      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={4}>
                          Subject:
                        </Col>
                        <Col className="gutter-row" span={12}>
                          {this.state.msgData.subject}
                        </Col>
                      </Row>
                    ) : null}
                    {!!this.state.msgDate ? (
                      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={4}>
                          Date:
                        </Col>
                        <Col className="gutter-row" span={12}>
                          {this.state.msgDate}
                        </Col>
                      </Row>
                    ) : null}
                    <Divider orientation="left">Body</Divider>
                    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                      <Col className="gutter-row" span={16}>
                        {this.state.msgData.body}
                      </Col>
                    </Row>
                    {this.state.msgData.attachments && this.state.msgData.attachments.length > 0 ? (
                      <>
                        <Divider orientation="left">Attachments</Divider>
                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                          {this.state.msgData.attachments.map((attach, i) => {
                            return (
                              <Col id={'col-attach-body' + i} key={attach} className="gutter-row" span={16}>
                                <p>
                                  {attach.fileName} ({attach.contentLength} bytes)
                                  <button
                                    data-index={i}
                                    style={{ margin: '10px' }}
                                    onClick={this.downloadAttachment}
                                    className="ant-btn ant-btn-default"
                                    id={'attach-' + i}
                                    title="Download"
                                  >
                                    Download
                                  </button>
                                </p>
                              </Col>
                            );
                          })}
                        </Row>
                      </>
                    ) : null}
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <div>
                  Preview for this file type is not supported currently.
                  <br />
                  Click
                  <a href="#" onClick={this.downloadOriginalFile} style={{ padding: '0px 5px' }}>
                    here
                  </a>
                  to download the original file.
                </div>
              </>
            )}
          </>
        ) : null}
      </Modal>
    );
  }
}
